(function () {

  'use strict';

  eclipseApp.factory('updateSimCardService', function() {

              var newSimNumber = '';

              function setNewSimNumber(data) {
                  newSimNumber = data;
              }

              function getNewSimNumber() {
                  return newSimNumber;
              }

              return {

                  setNewSimNumber: setNewSimNumber,
                  getNewSimNumber: getNewSimNumber
              }

          });

})();
